import { render, staticRenderFns } from "./discount.vue?vue&type=template&id=47c0b21c&scoped=true&"
import script from "./discount.vue?vue&type=script&lang=js&"
export * from "./discount.vue?vue&type=script&lang=js&"
import style0 from "./discount.vue?vue&type=style&index=0&id=47c0b21c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c0b21c",
  null
  
)

export default component.exports